import React, { useContext, useRef } from 'react';
import { Button, Select, Form, Input, Rate, Row, Col } from 'antd';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { create_guest_quotation_recommendation } from 'services/apiSrv';
import Loader from 'components/widgets/loader';
import { DashboardContext } from 'context/DashboardContext';
import { ModalContext } from 'context/ModalContext';
import { KycContext } from 'context/KycContext';
import { show_toast } from 'utils/helpers';
import debounce from 'debounce';

function ClientProductRecommendation({ risks, client_quotation_id, onRecommendationAdded, loading, setLoading }) {
    const { recommendation } = useContext(DashboardContext); // Removed setRecommendation if unused
    const { modalClose } = useContext(ModalContext);
    const { setCurrent } = useContext(KycContext);
    const { TextArea } = Input;
    const { Option } = Select;

    const updatedRisks = risks?.map((risk) => {
        const formItem = risk.risk_form?.find((item) => item.name === 'SSF00013724');
        return {
            ...risk,
            name: formItem?.value || 'Unnamed Risk',
        };
    });

    async function getUnderwriters() {
        // const resp = await get_underwriters_requests();
        return [] // Fixed typo
    }

    const { data, isSuccess, isLoading } = useQuery('fetch underwriters', getUnderwriters);

    const queryClient = useQueryClient();
    const isSubmittingRef = useRef(false);

    const postRecommendationForm = useMutation(create_guest_quotation_recommendation, {
        onSuccess: () => {
            isSubmittingRef.current = true;
            // Invalidate the same query key as in SingleClientQuotation
            queryClient.invalidateQueries(['guestClientRecommendations', client_quotation_id]);
            setCurrent(0);
            show_toast('Recommendation added successfully', 'success');
            onRecommendationAdded(); // Trigger refetch and modal close
            isSubmittingRef.current = false;
        },
        onError: (error) => {
            console.error('Error adding recommendation:', error);
            show_toast('Failed to add recommendation', 'error');
            setLoading(false);
            modalClose();
            isSubmittingRef.current = false;
        },
    });

    const onFinish = debounce((values) => {
        if (isSubmittingRef.current) return; // Prevent multiple submissions
        setLoading(true);

        const data = {
            product_id: recommendation.product_id,
            guest_client_quotation_id: client_quotation_id,
            recommendation_level: values.recommendation_level,
            recommendation_remarks: values.recommendation_remarks,
            special_code: values.special_code,
            risks: [values.risks],
        };

        postRecommendationForm.mutate(data);
    }, 400);

    const validateMessages = {
        required: '${label} is required!',
    };

    return (
        <div>
            {isLoading && <Loader />}
            {isSuccess && (
                <Form
                    name="clientRecommendationForm"
                    onFinish={onFinish}
                    layout="vertical"
                    validateMessages={validateMessages}
                >
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Recommendation Level"
                                name="recommendation_level"
                                rules={[{ required: true }]}
                            >
                                <Rate />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Risk" name="risks">
                                <Select
                                    showSearch
                                    placeholder="Select Risk"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    filterSort={(a, b) =>
                                        String(a.children)
                                            .toLowerCase()
                                            .localeCompare(String(b.children).toLowerCase())
                                    }
                                >
                                    {updatedRisks?.map((option) => (
                                        <Option value={option?.risk_system_ref} key={option?.risk_system_ref}>
                                            {option?.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item
                        label="Remarks"
                        name="recommendation_remarks"
                        rules={[{ required: true }]}
                    >
                        <TextArea rows={4} />
                    </Form.Item>

                    {/* <Form.Item>
                        <Button type="primary" htmlType="submit" loading={loading} disabled={loading}>
                            Submit Recommendation
                        </Button>
                    </Form.Item> */}
                </Form>
            )}
        </div>
    );
}

export default ClientProductRecommendation;